module.exports = __webpack_public_path__ + "img/logoTop.65ea51fa.png";